import React from 'react'
import {BrandsItemDetalle} from './BrandsItemDetalle'

function BrandsItem(props) {
  const displayItems = (props) => {
    if (props) {
      const brands = props.brands
      if (brands) {
        if (brands.length > 0) {
          return brands.map((brand, index) => {
            return (
              <BrandsItemDetalle
                key={index}
                brand={brand}
                setBrands={props.setBrands}
                deleteBrand={props.deleteBrand}
              />
            )
          })
        } else {
          return <h3>No hay marcas</h3>
        }
      } else {
        return <h3>No hay marcas</h3>
      }
    } else {
      return <h3>No hay marcas</h3>
    }
  }

  return <>{displayItems(props)}</>
}

export {BrandsItem}
